import { render, staticRenderFns } from "./GenericHistoryContent.vue?vue&type=template&id=fa9a5e7e&"
import script from "./GenericHistoryContent.vue?vue&type=script&lang=js&"
export * from "./GenericHistoryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports